import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as dateFnsExports } from './p-iWCgRMLC.js';
import { d as defineCustomElement$6 } from './p-BbTg3Car.js';
import { d as defineCustomElement$5 } from './p-06zXtNjY.js';
import { d as defineCustomElement$4 } from './p-C78HRAnj.js';
import { d as defineCustomElement$3 } from './p-Cr5d_5Z4.js';
import { d as defineCustomElement$2 } from './p-CZA0kb6w.js';

const datetimeReadonlyCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:inline-block;flex-shrink:0;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host .container{display:inline-flex;flex-direction:column;gap:.25rem}:host .datetime{align-items:center;align-self:stretch;background-color:var(--jw-theme-info-muted-message-bg-color);border-radius:.25rem;color:var(--jw-theme-info-muted-message-color);display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;height:2rem;letter-spacing:-.0004em;line-height:1.25rem;padding:0 .5rem}";

const WuiDateTimeReadOnly = /*@__PURE__*/ proxyCustomElement(class WuiDateTimeReadOnly extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.generateUTCDisplayString = (date) => {
            if (!date || !dateFnsExports.isValid(date)) {
                return 'yyyy-mm-dd, --:--:--';
            }
            const dateUtc = date.toISOString().substring(0, 10);
            const timeUtc = date.toISOString().substring(11, 19);
            return `${dateUtc}, ${timeUtc}`;
        };
    }
    render() {
        return (h(Host, { key: '9c0d1cd6c0570bab58e35885ca13bdab397b52df' }, h("span", { key: '5544da8317f37c964777191047f7e5bb0ab3eb64', class: "container" }, h("wui-form-field", { key: '59dc30cd7c5fa17481f31b9fa8d8fb2b0a337880', label: "UTC" }, h("span", { key: '47462026b34d8c779edee37726fbb1a28e83e863', class: "datetime" }, this.generateUTCDisplayString(this.date))))));
    }
    static get style() { return datetimeReadonlyCss; }
}, [257, "wui-datetime-readonly", {
        "date": [16]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-datetime-readonly", "wui-box", "wui-form-field", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-datetime-readonly":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiDateTimeReadOnly);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiDatetimeReadonly = WuiDateTimeReadOnly;
const defineCustomElement = defineCustomElement$1;

export { WuiDatetimeReadonly, defineCustomElement };
